import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const DefaultImageIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "DefaultImageIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3ZM4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1463 9.68572C16.9413 9.50731 16.6313 9.52532 16.4484 9.72627L11.658 14.9874C11.1315 15.5656 10.2491 15.6423 9.63073 15.1636L6.48682 12.73C6.25487 12.5505 5.91889 12.6082 5.76022 12.855L2.92068 17.2704L2.07959 16.7295L4.91914 12.3141C5.39513 11.5739 6.40307 11.4006 7.09894 11.9393L10.2428 14.3729C10.449 14.5324 10.7431 14.5069 10.9186 14.3141L15.709 9.05302C16.2579 8.45018 17.1878 8.39615 17.8028 8.93136L21.6617 12.2895L21.0052 13.0438L17.1463 9.68572Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.6665 8.33325C12.6665 9.43782 11.7711 10.3333 10.6665 10.3333C9.56193 10.3333 8.6665 9.43782 8.6665 8.33325C8.6665 7.22868 9.56193 6.33325 10.6665 6.33325C11.7711 6.33325 12.6665 7.22868 12.6665 8.33325Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default DefaultImageIcon;
